import {
  Card,
  CardContent,
} from "@/components/ui";
import useBomLeftSection from "./useBomLeftSection";
import { cn, yearOptions } from "@/lib/utils";
import { Select, FormLabel, FormSectionHeader } from "@/components";
import { ReportSection } from "../ReportSection";
import { BudgetExpenseChart } from "../BudgetExpenseChart";
import { BudgetIncomeChart } from "../BudgetIncomeChart";
import { CriticalActionSection } from "./CriticalActionSection";
import { FinancialOversight } from "./FinancialOversight";
import { Operational } from "./Operational";

const BomLeftSection = () => {
  const {
    loggedInUserData,
    communityDetail,
    firstSectionCard,
    navigate,
    currentFinanceYear,
    onYearChange,
    communityList,
    isCommunityLoading,
    onCommunityChange,
  } = useBomLeftSection();

  return (
    <div className="grid grid-cols-1 gap-[20px]">
      <div className="bg-white rounded-lg p-[20px] grid grid-cols-1 lg:grid-cols-3 gap-[10px]">
        <div className="flex flex-col col-span-2">
          <span className="font-[300] text-[24px]">
            Hello, {loggedInUserData?.fullName || ""}
            <br />{" "}
            <span className="font-[600]">{communityDetail?.name || ""}</span>
          </span>{" "}
        </div>
        <div className="flex gap-3 justify-end">
          {isCommunityLoading ? (
            <></>
          ) : (
            <div className="relative">
              <FormLabel>Select Community</FormLabel>
              <Select
                placeholder={""}
                searchPlaceholder={""}
                noDataPlaceholder={"Community No Found"}
                options={communityList?.data?.map((data: any) => ({
                  value: data?.communityId,
                  label: data?.name,
                }))}
                value={communityDetail?.communityId || ""}
                onChange={onCommunityChange}
                className="h-[36px] w-[200px]"
              />
            </div>
          )}
          <div className="relative">
            <FormLabel>Year</FormLabel>
            <Select
              showSearch={false}
              placeholder=""
              searchPlaceholder=""
              noDataPlaceholder=""
              options={yearOptions(5)?.map((d: any) => ({
                value: d.value,
                label: d.label,
              }))}
              value={currentFinanceYear}
              onChange={onYearChange}
              className="h-[36px] w-full"
            />
          </div>
        </div>
      </div>
      <CriticalActionSection />
      <ReportSection />
      <FinancialOversight />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        <BudgetExpenseChart />
        <BudgetIncomeChart />
      </div>
      <Operational />
      <div className="bg-white rounded-lg p-[20px]">
        <FormSectionHeader className="text-[18px] font-[500]">
          Community Info
        </FormSectionHeader>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[20px]">
          {firstSectionCard?.map((data: any) => {
            return (
              <Card className={cn("border-none", data?.className)}>
                <CardContent>
                  <div className="h-[50px] w-[50px] bg-white flex items-center justify-center rounded-full shadow-lg">
                    {data?.icon ? <data.icon /> : <></>}
                  </div>
                  <div className="mt-[20px]">
                    <span className="text-[16px] font-[600]">
                      {data?.count}
                    </span>{" "}
                    <br />
                    <span className="text-[12px] -mt-[10px]">
                      {data?.title}
                    </span>
                  </div>
                  {data?.data?.length ? (
                    <div
                      className={cn(
                        "grid grid-cols-1 p-2 rounded-lg mt-[10px]",
                        data?.dataClassName
                      )}
                      style={{
                        gridTemplateColumns: `repeat(${
                          data?.data?.length || 1
                        }, minmax(0, 1fr))`,
                      }}
                    >
                      {data?.data?.map((val: any, index: number) => {
                        return (
                          <div
                            className={cn(
                              "flex items-center justify-center",
                              data?.dataBorderColor,
                              index != data?.data?.length - 1
                                ? "border-r-2"
                                : ""
                            )}
                          >
                            <span className="text-[9px]">{val?.label}: </span>
                            <span
                              className={`text-[12px] ml-1 ${
                                val.link
                                  ? "border-b-1 border-b-primary text-primary cursor-pointer"
                                  : ""
                              }`}
                              onClick={() => {
                                val.link ? navigate(val.link) : "";
                              }}
                            >
                              {val?.count}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <></>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BomLeftSection;
